const abcLogo = "/images/abc-logo.png";

export const addCoverSlides = async (pres, mediaItems, slideWidth) => {
  const imageWidth = 2.2;
  const imageHeight = 3;
  const titleFont = 18;
  const dateFont = 12;

  const itemsPerSlide = 2;
  const itemsPerRow = 2;

  // Break mediaItems into chunks of 2
  for (let s = 0; s < mediaItems.length; s += itemsPerSlide) {
    const slideItems = mediaItems.slice(s, s + itemsPerSlide);
    const slide = pres.addSlide();

    // Background
    slide.background = {
      path: "/images/image.png",
      type: "online",
    };

    // Header
    slide.addImage({
      type: "online",
      path: "/images/disney.png",
      x: (slideWidth - 1.2) / 2,
      y: 0.3,
      w: 1.2,
      h: 1.2,
    });

    slide.addText("Disney Television Studios", {
      x: (slideWidth - 5) / 2,
      y: 1.6,
      w: 5,
      h: 0.3,
      fontSize: 13,
      color: "ffffff",
      align: "center",
    });

    slide.addText("Content & Brand Insights", {
      x: (slideWidth - 6) / 2,
      y: 2.0,
      w: 6,
      h: 0.5,
      fontSize: 20,
      bold: true,
      color: "ffffff",
      align: "center",
    });

    // Content
    const xPadding = 0.7;
    const colGap = 0.5;
    const blockWidth = (slideWidth - 2 * xPadding - colGap) / 2;
    const startY = 3.0;

    for (let i = 0; i < slideItems.length; i++) {
      const item = slideItems[i];
      const col = i % itemsPerRow;
      const row = Math.floor(i / itemsPerRow);

      let x = xPadding + col * (blockWidth + colGap);
      const y = startY + row * (imageHeight + 1.8);

      // Center align everything if only one item
      if (slideItems.length === 1) {
        x = (slideWidth - blockWidth) / 2;
      }

      try {
        // Poster
        if (item?.poster_url_base64) {
          slide.addImage({
            data: item?.poster_url_base64,
            x: x + (blockWidth - imageWidth) / 2,
            y,
            w: imageWidth,
            h: imageHeight,
          });
        }

        // Title
        slide.addText(item.title, {
          x,
          y: y + imageHeight + 0.2,
          w: blockWidth,
          h: 0.4,
          fontSize: titleFont,
          bold: true,
          color: "ffffff",
          align: "center",
        });

        // Date
        const formattedDate = new Date(item.date_added)
          .toISOString()
          .split("T")[0];

        slide.addText(`Date Added: ${formattedDate}`, {
          x,
          y: y + imageHeight + 0.7,
          w: blockWidth,
          h: 0.3,
          fontSize: dateFont,
          color: "ffffff",
          align: "center",
        });
      } catch (err) {
        console.error("❌ Image fetch error:", item.title, err);
      }
    }
  }
};

export const addCommonHeader = (slide, mediaPromos, slideWidth) => {
  // const slideWidth = 7.5;

  slide.addShape("rect", {
    x: 0,
    y: 0,
    w: slideWidth,
    h: 1,
    fill: { color: "1f3b6f" },
    line: { color: "000000", width: 1 },
  });

  mediaPromos.forEach((media, i) => {
    slide.addText(`${i + 1}. ${media?.title}`, {
      x: 0,
      y: 0.15 + i * 0.3,
      w: slideWidth,
      h: 0.3,
      fontSize: 14,
      bold: true,
      color: "ffffff",
      align: "center",
    });
  });
};

export const addPromoHeader = (slide, mediaPromos, fieldedDate, slideWidth) => {
  const halfWidth = slideWidth / 2;

  // === Section 1: Left Side Header Background ===
  slide.addShape("rect", {
    x: 0,
    y: 0,
    w: slideWidth,
    h: 1,
    fill: { color: "1f3b6f" },
    line: { color: "000000", width: 1 },
  });

  // === Section 1: Left Text (Promo Titles) ===
  mediaPromos.forEach((media, i) => {
    slide.addText(`${i + 1}. ${media?.title}`, {
      x: 0.2,
      y: 0.15 + i * 0.3,
      w: halfWidth - 0.4,
      h: 0.3,
      fontSize: 12,
      bold: true,
      color: "ffffff",
    });
  });

  // === Section 2: Right Text Block (Date + Desc) ===
  slide.addText(
    `PROMO RESULTS\n${fieldedDate}\nPROMO RANKING BY DEMO BREAKS\n“Make every effort to watch”`,
    {
      x: halfWidth + 0.2,
      y: 0.15,
      w: halfWidth - 0.4,
      h: 0.8,
      fontSize: 10,
      color: "ffffff",
      valign: "top",
      align: "left",
      lineSpacing: 12,
    }
  );
};

export const addPromoResultsHeader = (slide, fieldedDate, slideWidth) => {
  // PROMO RESULTS
  slide.addText("PROMO RESULTS", {
    x: 0.5,
    y: 1.2,
    w: slideWidth - 1,
    h: 0.3,
    fontSize: 14,
    bold: true,
    color: "000000",
    align: "center",
  });

  // MOBILE SURVEY FIELDED …
  slide.addText(`MOBILE SURVEY FIELDED`, {
    x: 0.5,
    y: 1.5,
    w: slideWidth - 1,
    h: 0.3,
    fontSize: 10,
    color: "333333",
    align: "center",
  });

  // DATE ONLY (if you still want it shown a 2nd time)
  // Remove this block if it's redundant:
  slide.addText(`${fieldedDate}`, {
    x: 0.5,
    y: 1.8, // bumped down so it doesn’t overlap
    w: slideWidth - 1,
    h: 0.3,
    fontSize: 10,
    color: "333333",
    align: "center",
  });
};

export const addCommonFooter = (slide, slideWidth, footnoteText) => {
  // Add ABC logo
  slide.addImage({
    type: "online",
    path: abcLogo,
    x: slideWidth - 1.1,
    y: 9.2,
    w: 0.8,
    h: 0.8,
  });

  // Add footnote
  slide.addText(footnoteText, {
    x: 0.2,
    y: 9.4,
    w: slideWidth - 1.4,
    h: 0.7,
    fontSize: 7,
    color: "cc0000",
    wrap: true,
  });
};
export const addOverviewSummarySlide = (
  pres,
  uniquePromos,
  summaryData,
  fieldedDate,
  slideWidth
) => {
  // const slideWidth = 7.5;
  const slideHeight = 10;
  const contentStartY = 2.4;
  const footerReservedY = 1.2; // space for logo + footer text
  const contentMaxY = slideHeight - footerReservedY;

  const addNewSlide = () => {
    const slide = pres.addSlide();
    addCommonHeader(slide, uniquePromos, slideWidth);
    addPromoResultsHeader(slide, fieldedDate, slideWidth);

    // Slide title
    slide.addText("OVERALL SUMMARY", {
      x: 0.5,
      y: 2.0,
      w: slideWidth - 1,
      h: 0.4,
      fontSize: 18,
      bold: true,
      color: "000000",
    });

    // Add footer logo and methodology
    slide.addImage({
      path: abcLogo,
      type: "online",
      x: slideWidth - 1.1,
      y: slideHeight - 1,
      w: 0.8,
      h: 0.8,
    });

    slide.addText(
      "METHODOLOGY: 300 per promo (100 women, 100 men, 100 A18-34, 100 A35-49) TV viewers 18-49 and 100 50-64 year olds evaluated one promo and then were asked a series of questions as part of a mobile survey.",
      {
        x: 0.5,
        y: slideHeight - 0.6,
        w: slideWidth - 1,
        h: 0.6,
        fontSize: 7,
        color: "cc0000",
        align: "left",
      }
    );

    return slide;
  };

  let slide = addNewSlide();
  let y = contentStartY;

  summaryData.forEach((item) => {
    const subtitleHeight = 0.4;
    const contentHeight = 1.5;
    const spacing = 0.4;
    const blockHeight = subtitleHeight + contentHeight + spacing;

    if (y + blockHeight > contentMaxY) {
      slide = addNewSlide();
      y = contentStartY;
    }

    slide.addText(item.subtitle, {
      x: 0.5,
      y,
      w: slideWidth - 1,
      h: subtitleHeight,
      fontSize: 14,
      bold: true,
      color: "0563C1",
      underline: true,
      hyperlink: {
        url: item?.redirect_uri,
      },
    });

    y += subtitleHeight;

    slide.addText(item.summary_content, {
      x: 0.5,
      y,
      w: slideWidth - 1,
      h: contentHeight,
      fontSize: 11,
      color: "000000",
      valign: "top",
      lineSpacing: 14,
      bullet: false,
      wrap: true,
    });

    y += contentHeight + spacing;
  });
};

export const addInterestDriversSlide = (
  pres,
  uniquePromos,
  interestDrivers,
  fieldedDate,
  slideWidth
) => {
  const slide = pres.addSlide();
  const headerFill = "3465a4";
  addCommonHeader(slide, uniquePromos, slideWidth);
  addPromoResultsHeader(slide, fieldedDate, slideWidth);

  // Extract column keys dynamically (excluding 'name')
  const allColumns = Object.keys(
    interestDrivers.reduce((acc, row) => {
      Object.entries(row).forEach(([key, value]) => {
        if (key !== "name" && value > 0) {
          acc[key] = true;
        }
      });
      return acc;
    }, {})
  );

  // Header row
  const headerRow = [
    {
      text: "Key Interests",
      options: {
        bold: true,
        fill: headerFill,
        color: "FFFFFF",
        align: "center",
        border: { type: "none" },
      },
    },
    ...allColumns.map((col) => ({
      text: col,
      options: {
        bold: true,
        fill: headerFill,
        color: "FFFFFF",
        align: "center",
        border: { type: "none" },
      },
    })),
  ];

  // Data rows
  const dataRows = interestDrivers.map((row) => [
    {
      text: row.name,
      options: {
        align: "left",
        border: { pt: 1, color: "999999" },
      },
    },
    ...allColumns.map((col) => ({
      text: `${row[col] || 0}%`,
      options: {
        align: "center",
        border: { pt: 1, color: "999999" },
      },
    })),
  ]);

  const tableRows = [headerRow, ...dataRows];

  // Calculate column widths and table width
  const colW = [3.5, ...allColumns.map(() => 1.5)];
  const tableWidth = colW.reduce((sum, w) => sum + w, 0);

  // Center the table horizontally
  const xPos = (slideWidth - tableWidth) / 2;

  slide.addTable(tableRows, {
    x: xPos,
    y: 2.5,
    w: tableWidth,
    colW,
    fontSize: 11,
  });

  addCommonFooter(
    slide,
    slideWidth,
    "METHODOLOGY: 300 per promo (100 women, 100 men, 100 A18-34, 100 A35-49) TV viewers 18-49 and 100 50-64 year olds evaluated one promo and then were asked a series of questions as part of a mobile survey."
  );
};

export const addUserChartSlide = (
  pres,
  uniquePromos,
  chartSets,
  fieldedDate,
  slideWidth,
  ageOrdered
) => {
  const chartHeight = 2.0;
  const sectionGap = 2.4;
  const sectionStartY = 1.15;
  const normDashStyle = { pt: 1, color: "f4b942", dashType: "dash" };

  // Filter only valid chart sets (at least one bar > 0)
  const validSets = chartSets.filter((set) =>
    set.bars.some((bar) => bar.value > 0)
  );

  // Build a quick lookup map for fast access
  const chartMap = {};
  validSets.forEach((set) => {
    chartMap[set.ageLabel] = set;
  });

  // Loop over each group of demos for slide
  ageOrdered.forEach((ageGroup) => {
    // Filter to only demos present in the input
    const chartGroup = ageGroup.map((d) => chartMap[d]).filter(Boolean);

    if (chartGroup.length === 0) return;

    const slide = pres.addSlide();
    addPromoHeader(slide, uniquePromos, fieldedDate, slideWidth);

    chartGroup.forEach((set, idx) => {
      const baseY = sectionStartY + idx * sectionGap + idx * 0.1;

      // Frame
     slide.addShape("rect", {
        x: 0.1,
        y: baseY,
        w: slideWidth - 0.2,
        h: sectionGap - 0.1,
        line: { color: set.brandColor || "cccccc", width: 1 },
        fill: { color: "FFFFFF", transparency: 100 },
      });

      // Label
      slide.addText(set.ageLabel, {
        x: 0.25,
        y: baseY - 0.05,
        w: 2.5,
        h: 0.3,
        align: "left",
        fontSize: 12,
        bold: true,
        color: "1f3b6f",
        line: { color: "1f3b6f", width: 1 },
        fill: { color: "ffffff" },
      });

      // Chart
      slide.addChart(
        pres.ChartType.bar,
        [
          {
            name: "Series 1",
            labels: set.bars.map((b) => b.label),
            values: set.bars.map((b) => b.value),
          },
        ],
        {
          x: 0.4,
          y: baseY + 0.25,
          w: slideWidth - 0.8,
          h: chartHeight,
          chartColors: set.bars.map((b) => b.color),
          showLegend: false,
          catAxisHidden: false,
          valAxisHidden: true,
          dataLabelFontSize: 10,
          showValue: true,
          dataLabelColor: "000000",
          dataLabelFormatCode: "0",
          dataLabelPosition: "outEnd", // <-- this is the key
          barGapWidthPct: 60,
        }
      );

      // Norm line
      const normX0 = 0.4;
      const normX1 = slideWidth - 0.4;
      const normY = baseY + 0.25 + chartHeight - (set.norm / 100) * chartHeight;

      slide.addShape("line", {
        x: normX0,
        y: normY,
        w: normX1 - normX0,
        h: 0,
        line: normDashStyle,
      });

      // Norm label
      slide.addShape("rect", {
        x: normX0 - 0.25,
        y: normY - 0.15,
        w: 0.45,
        h: 0.3,
        fill: { color: "f4b942" },
        line: { color: "f4b942" },
      });
      slide.addText(`Norm\n${set.norm}`, {
        x: normX0 - 0.25,
        y: normY - 0.15,
        w: 0.6,
        h: 0.3,
        fontSize: 8,
        color: "ffffff",
        align: "center",
        valign: "middle",
      });
    });

    // Footer
    const footnote = `NOTE: “Norm” = avg. performance across comparable titles. 300 completes per promo (100 W18‑49, 100 M18‑49, 100 A18‑34, 100 A35‑49; plus 100 A50‑64).`;
    addCommonFooter(slide, slideWidth, footnote);
  });
};

export const addStreamPlatformSlide = (
  pres,
  uniquePromos,
  fieldedDate,
  streamSets,
  slideWidth
) => {
  const slide = pres.addSlide();

  // Add header
  addPromoHeader(slide, uniquePromos, fieldedDate, slideWidth);

  // Define row layouts dynamically based on slideWidth
  const gap = 0.5;

  // Row 1: 2 tables
  const row1 = (() => {
    const tableWidth = 2.6;
    const totalWidth = tableWidth * 2 + gap;
    const startX = (slideWidth - totalWidth) / 2;
    const y = 1.3;
    return [
      { x: startX, y, w: tableWidth },
      { x: startX + tableWidth + gap, y, w: tableWidth },
    ];
  })();

  // Row 2: 3 tables
  const row2 = (() => {
    const tableWidth = 2.1;
    const totalWidth = tableWidth * 3 + gap * 2;
    const startX = (slideWidth - totalWidth) / 2;
    const y = 3.3;
    return [
      { x: startX, y, w: tableWidth },
      { x: startX + tableWidth + gap, y, w: tableWidth },
      { x: startX + (tableWidth + gap) * 2, y, w: tableWidth },
    ];
  })();

  // Row 3: 1 centered table
  const row3 = (() => {
    const tableWidth = 2.3;
    const x = (slideWidth - tableWidth) / 2;
    const y = 5.9;
    return [{ x, y, w: tableWidth }];
  })();

  // Combine all grid positions
  const grid = [...row1, ...row2, ...row3];

  const headerColors = ["4b88d2", "d24b4b", "767676"];

  // Render each table block
  streamSets.forEach((block, idx) => {
    const pos = grid[idx];
    if (!pos) return;

    const headerFill = headerColors[idx % headerColors.length];

    const rows = [
      [
        {
          text: block.name,
          options: {
            bold: true,
            fill: headerFill,
            color: "ffffff",
            align: "center",
            border: { type: "none" },
          },
        },
        {
          text: "",
          options: {
            fill: headerFill,
            border: { type: "none" },
          },
        },
      ],
    ];

    block.rows.forEach((r) => {
      rows.push([
        {
          text: r.label,
          options: {
            align: "left",
            color: "000000",
            fontSize: 10,
          },
        },
        {
          text: `${r.value}%`,
          options: {
            align: "center",
            color: "000000",
            fontSize: 10,
          },
        },
      ]);
    });

    slide.addTable(rows, {
      x: pos.x,
      y: pos.y,
      w: pos.w,
      colW: [pos.w * 0.65, pos.w * 0.35],
      fontSize: 10,
      border: {
        type: "solid",
        color: headerFill,
        pt: 1,
      },
      fill: "ffffff",
    });
  });

  // Add footer
  const footnote =
    "METHODOLOGY: N= 200 per promo. TV viewers 18-64 evaluated one promo and then were asked a series of questions as part of a mobile survey.";
  addCommonFooter(slide, slideWidth, footnote);
};

export const addDemographicTableSlide = (
  pres,
  userChartData,
  uniquePromos,
  fieldedDate,
  slideWidth
) => {
  const slide = pres.addSlide();

  // Add header
  addPromoHeader(slide, uniquePromos, fieldedDate, slideWidth);

  const gap = 0.5;

  // Row 1: 2 tables
  const row1 = (() => {
    const tableWidth = 2.6;
    const totalWidth = tableWidth * 2 + gap;
    const startX = (slideWidth - totalWidth) / 2;
    const y = 1.3;
    return [
      { x: startX, y, w: tableWidth },
      { x: startX + tableWidth + gap, y, w: tableWidth },
    ];
  })();

  // Row 2: 3 tables
  const row2 = (() => {
    const tableWidth = 2.1;
    const totalWidth = tableWidth * 3 + gap * 2;
    const startX = (slideWidth - totalWidth) / 2;
    const y = 3.3;
    return [
      { x: startX, y, w: tableWidth },
      { x: startX + tableWidth + gap, y, w: tableWidth },
      { x: startX + (tableWidth + gap) * 2, y, w: tableWidth },
    ];
  })();

  // Row 3: 1 centered table
  const row3 = (() => {
    const tableWidth = 2.3;
    const x = (slideWidth - tableWidth) / 2;
    const y = 5.9;
    return [{ x, y, w: tableWidth }];
  })();

  // Combine all positions
  const grid = [...row1, ...row2, ...row3];

  const headerColors = ["4b88d2", "d24b4b", "767676"];

  // Render tables
  userChartData.slice(0, 6).forEach((block, idx) => {
    const pos = grid[idx];
    if (!pos) return;

    const headerFill = headerColors[idx % headerColors.length];

    const rows = [
      [
        {
          text: block?.ageLabel,
          options: {
            bold: true,
            fill: headerFill,
            color: "ffffff",
            align: "center",
            border: { type: "none" },
          },
        },
        {
          text: "",
          options: {
            fill: headerFill,
            border: { type: "none" },
          },
        },
      ],
    ];

    block.bars.forEach((bar) => {
      rows.push([
        {
          text: bar.label,
          options: {
            align: "left",
            color: "000000",
            fontSize: 10,
          },
        },
        {
          text: `${bar.value}%`,
          options: {
            align: "center",
            color: "000000",
            fontSize: 10,
          },
        },
      ]);
    });

    slide.addTable(rows, {
      x: pos.x,
      y: pos.y,
      w: pos.w,
      colW: [pos.w * 0.65, pos.w * 0.35],
      fontSize: 10,
      border: { type: "solid", color: headerFill, pt: 1 },
      fill: "ffffff",
    });
  });

  // Footer
  const footnote = `METHODOLOGY: 300 per promo (100 women, 100 men, 100 A18-34, 100 A35-49) TV viewers 18-49 and 100 50-64 year olds evaluated one promo and then were asked a series of questions as part of a mobile survey.`;

  addCommonFooter(slide, slideWidth, footnote);
};

export const addTopDescriptorsSlides = (
  pres,
  uniquePromos,
  descriptorSets,
  universalLabels,
  fieldedDate,
  slideWidth
) => {
  // const sw = 7.5;
  const rowHeight = 2.4; // Height per table row pair (you can tune this)
  const startY = 1.7;
  const maxY = 6.5;

  let currentY = startY;
  let slide = pres.addSlide();

  const addSlideHeaderAndFooter = () => {
    addPromoHeader(slide, uniquePromos, fieldedDate, slideWidth);
    const titleWidth = 2.5;
    const noteWidth = 4.5;
    const gapBetween = 0.5;
    const totalBlockWidth = titleWidth + gapBetween + noteWidth;

    const startX = (slideWidth - totalBlockWidth) / 2;

    slide.addText("Top Descriptors", {
      x: startX,
      y: 1.1,
      w: titleWidth,
      h: 0.3,
      fontSize: 12,
      bold: true,
      align: "center",
      fill: { color: "ffffff" },
      line: { color: "1f3b6f", width: 1 },
    });

    slide.addText("Descriptors repeated across all ads are in green", {
      x: startX + titleWidth + gapBetween,
      y: 1.13, // slight tweak for alignment if needed
      w: noteWidth,
      h: 0.25,
      fontSize: 10,
      color: "333333",
      align: "left",
    });

    const footnote = `Q19 COMEDYDESCRIPTORS. Based on the ad you viewed, please select the words and phrases that you think best describe the show HISTORY OF THE WORLD, PART II. Please select all that apply.`;
    addCommonFooter(slide, slideWidth, footnote);
  };

  addSlideHeaderAndFooter();

  for (let i = 0; i < descriptorSets.length; i += 2) {
    if (currentY + rowHeight > maxY) {
      slide = pres.addSlide();
      currentY = startY;
      addSlideHeaderAndFooter();
    }

    const currentChunk = descriptorSets.slice(i, i + 2);
    // const grid = [
    //   { x: 0.25, y: currentY, w: 3.2 },
    //   { x: 4.0, y: currentY, w: 3.2 },
    // ];
    const tableWidth = 3.2;
    const gapBetweenTables = 0.5;
    const totalWidth = tableWidth * 2 + gapBetweenTables;
    const startX = (slideWidth - totalWidth) / 2;

    const grid = [
      { x: startX, y: currentY, w: tableWidth },
      { x: startX + tableWidth + gapBetweenTables, y: currentY, w: tableWidth },
    ];

    currentChunk.forEach((set, idx) => {
      if (!set) return;
      const g = grid[idx];

      const rows = [
        [
          {
            text: set.promo,
            options: {
              bold: true,
              align: "center",
              fill: "d9d9d9",
              border: { type: "none" },
            },
          },
          { text: "", options: { fill: "d9d9d9", border: { type: "none" } } },
        ],
      ];

      set.rows.forEach(({ label, value }) => {
        const color = universalLabels.has(label) ? "008000" : "000000";

        const displayValue = isNaN(Number(value))
          ? "0.0"
          : Number(value).toFixed(1);

        rows.push([
          { text: label, options: { color, fontSize: 9 } },
          {
            text: `${displayValue}%`,
            options: { color, fontSize: 9, align: "right" },
          },
        ]);
      });

      slide.addTable(rows, {
        x: g.x,
        y: g.y,
        w: g.w,
        colW: [g.w * 0.6, g.w * 0.4],
        fontSize: 9,
        border: { type: "solid", color: "999999", pt: 1 },
        fill: "ffffff",
      });
    });

    currentY += rowHeight;
  }
};

export const addOpenEndedCommentsTables = (
  pres,
  uniquePromos,
  open_end_data,
  universalLabels,
  fieldedDate = "XX/XX/XX",
  slideWidth
) => {
  const slide = pres.addSlide();
  addPromoHeader(slide, uniquePromos, fieldedDate, slideWidth);

  slide.addText("Open Ended Comments", {
    x: 0.5,
    y: 0.9,
    w: 6.5,
    h: 0.5,
    fontSize: 16,
    bold: true,
    align: "center",
  });

  let currentY = 1.5;

  open_end_data.forEach((block, index) => {
    const comments = block.media_subtitle || [];

    // Section header (optional)
    slide.addText(`Media Item ${index + 1}`, {
      x: 0.5,
      y: currentY,
      w: 6.5,
      h: 0.3,
      fontSize: 12,
      bold: true,
    });

    currentY += 0.4;

    // Dynamic Table Header
    const headers = ["Comment", "Sentiment", "Topics"]; // Array for dynamic headers

    const rows = [
      headers.map((header) => ({
        text: header,
        options: {
          bold: true,
          fill: "3465a4",
          color: "ffffff",
          align: "center",
        },
      })),
    ];

    comments.forEach((item) => {
      rows.push([
        {
          text: item.comment,
          options: { fontSize: 9 },
        },
        {
          text: item.sentiment,
          options: {
            fontSize: 9,
            color: item.sentiment === "positive" ? "008000" : "cc0000",
            bold: true,
          },
        },
        {
          text: item.topics?.map((t) => t.topic).join(", ") || "-",
          options: { fontSize: 9 },
        },
      ]);
    });

    slide.addTable(rows, {
      x: 0.5,
      y: currentY,
      w: 6.5,
      colW: [3.7, 1.0, 1.8],
      border: { pt: 1, color: "cccccc" },
      fontSize: 10,
    });

    currentY += 0.8 + comments.length * 0.4;

    // Add another slide if content goes below the page
    if (currentY > 6.0 && index < open_end_data.length - 1) {
      slide = pres.addSlide();
      currentY = 0.5;
    }
  });
};

export const addSingleMediaTargetSlide = (
  pres,
  uniquePromos,
  genderData,
  slideWidth,
  surveyDate
) => {
  const slide = pres.addSlide();

  // Add standard header
  addCommonHeader(slide, uniquePromos, slideWidth);

  // Pass clean title string to promo header
  addPromoResultsHeader(slide, surveyDate, slideWidth);

  slide.addText("Target Audience by Gender", {
    x: 0.5,
    y: 2.3,
    fontSize: 16,
    bold: true,
    w: slideWidth - 1,
  });
  const baseY = 1.8;
  const chartHeight = Math.min(genderData.length * 0.6, 3.5);

  const bars = genderData.map((item) => ({
    label: item.name,
    value: item.value,
    color: item.color || "4472C4",
  }));
  const chartData = [
    {
      name: "Audience",
      labels: bars.map((b) => b.label),
      values: bars.map((b) => b.value),
    },
  ];

  slide.addChart(pres.ChartType.bar, chartData, {
    x: 0.4,
    y: baseY + 1.25,
    w: slideWidth - 0.8,
    h: chartHeight,
    chartColors: bars.map((b) => b.color),
    showLegend: false,
    catAxisHidden: false,
    valAxisHidden: true,
    dataLabelFontSize: 10,
    showValue: true,
    dataLabelColor: "000000",
    dataLabelFormatCode: "0.0",
    dataLabelPosition: "outEnd",
    barGapWidthPct: 60,
  });

  addCommonFooter(
    slide,
    slideWidth,
    "METHODOLOGY: 300 per promo (100 women, 100 men, 100 A18-34, 100 A35-49) TV viewers 18-49 and 100 50-64 year olds evaluated one promo and then were asked a series of questions as part of a mobile survey."
  );
};

export const addGenderTableSlide = (
  pres,
  uniquePromos,
  genderData,
  slideWidth,
  surveyDate
) => {
  const slide = pres.addSlide();

  // Header
  addCommonHeader(slide, uniquePromos, slideWidth);
  addPromoResultsHeader(slide, surveyDate, slideWidth);

  // Title for this chart section — moved lower to avoid overlap
  slide.addText("Target Audience by Gender", {
    x: 0.5,
    y: 2,
    fontSize: 16,
    bold: true,
    w: slideWidth - 1,
  });

  if (!genderData || genderData.length === 0) {
    slide.addText("No gender data available.", {
      x: 1,
      y: 2,
      fontSize: 14,
      italic: true,
    });
    return;
  }

  const rows = [
    ["Audience Group", "Percentage"],
    ...genderData.map((item) => [item.name, `${item.value.toFixed(1)}%`]),
  ];
  slide.addTable(rows, {
    x: 0.5,
    y: 3.0, // adjust so it's just under the chart title
    w: slideWidth - 1,
    colW: [slideWidth * 0.6, slideWidth * 0.3],
    border: { pt: 1, color: "CCCCCC" },
    fontSize: 12,
    fill: "F9F9F9",
    color: "000000",
    valign: "middle",
    align: "left",
    rowHeight: 0.4,
    bold: true,
  });

  // Footer
  addCommonFooter(
    slide,
    slideWidth,
    "METHODOLOGY: 300 per promo (100 women, 100 men, 100 A18-34, 100 A35-49) TV viewers 18-49 and 100 50-64 year olds evaluated one promo and then were asked a series of questions as part of a mobile survey."
  );
};
